import {createAsyncThunk} from '@reduxjs/toolkit';

import {ILookupEntry} from 'shared/types/lookups';

import {REPORT_CONFIGURATION_SLICE} from '../report-configuration-constants';
import {IFetchTableReportColumnsRequestArgs, fetchTableReportColumns, fetchTableReportFilterConditions} from './dd-lookups-api';
import {IReportTableColumn} from './dd-lookups-types';

export const loadTableReportColumnsLookup = createAsyncThunk<
    IReportTableColumn[],
    IFetchTableReportColumnsRequestArgs>(
        `${REPORT_CONFIGURATION_SLICE}/loadTableReportColumnsLookup`,
        async (args, {rejectWithValue}) => {
            try {
                const {data} = await fetchTableReportColumns(args);
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const loadTableReportConfigurationFilterConditionsLookup = createAsyncThunk<
    ILookupEntry[],
    void>(
        `${REPORT_CONFIGURATION_SLICE}/loadTableReportConfigurationFilterConditionsLookup`,
        async (args, {rejectWithValue}) => {
            try {
                const {data} = await fetchTableReportFilterConditions();
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );
